import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { MapPin, Activity, TrendingUp, History } from "lucide-react";

interface CityActivityHeaderProps {
  cityName: string;
  activityName: string;
  mode: 'trending' | 'alltime';
  onModeChange: (mode: 'trending' | 'alltime') => void;
  totalListings?: number;
}

export const CityActivityHeader = ({ 
  cityName, 
  activityName, 
  mode, 
  onModeChange,
  totalListings = 0
}: CityActivityHeaderProps) => {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <MapPin className="w-8 h-8 text-primary" />
        <h1 className="text-4xl md:text-5xl font-bold">
          {activityName} en {cityName}
        </h1>
      </div>

      <p className="text-lg text-muted-foreground mb-6">
        Los mejores lugares para {activityName.toLowerCase()} según la comunidad de Ekselencia
      </p>

      <div className="flex items-center gap-4 flex-wrap">
        <Badge variant="secondary" className="text-base px-4 py-2">
          <Activity className="w-4 h-4 mr-2" />
          {totalListings} lugares
        </Badge>

        <div className="flex gap-2">
          <Button
            variant={mode === 'trending' ? 'default' : 'outline'}
            onClick={() => onModeChange('trending')}
            className="gap-2"
          >
            <TrendingUp className="w-4 h-4" />
            Tendencias
          </Button>
          <Button
            variant={mode === 'alltime' ? 'default' : 'outline'}
            onClick={() => onModeChange('alltime')}
            className="gap-2"
          >
            <History className="w-4 h-4" />
            Histórico
          </Button>
        </div>
      </div>
    </div>
  );
};
